module.exports = __webpack_public_path__ + "static/media/BitvoLogo_.ea6a6248.jpg";